module Meevo.Components.AiChat {
  angular.module("meevo.components.aichat", []);
}